'use es6';

import { map } from 'rxjs/operators/map';
import http from 'hub-http-rxjs/clients/apiClient';
import VideoMap from '../models/VideoMap';
const INDEXER_BASE_PATH = 'cosindex/api/v1';
export default {
  fetchContentVideos(id) {
    const query = {
      childType: 'VIDEO_PLAYER',
      id
    };
    return http.get(`${INDEXER_BASE_PATH}/connections/children`, {
      query
    }).pipe(map(VideoMap.fromJS));
  }
};